import { forwardRef } from 'react'
import { useRecoilState } from 'recoil'
import TradeHistory from '@/components/trade/TradeHistory'
import { marketMapState } from '@/recoil/Market'
import { recentTradesState } from '@/recoil/RecentTrades'
import './RecentTrades.css'

export default forwardRef(function RecentTrades({ children, ...props }, ref) {
  props = {
    ref,
    ...props,
    className: `${props.className} card noselect recent-trades`
  }

  const [marketMap] = useRecoilState(marketMapState)
  const [recentTrades] = useRecoilState(recentTradesState)
  const marketInfo = marketMap[recentTrades.symbol] || {}

  const tradeHistoryList = recentTrades.list.map(history => (
    <TradeHistory
      key={`${history.id}`}
      priceFormat={marketInfo.priceDecimal}
      sizeFormat={marketInfo.sizeDecimal}
      {...history}
    />
  ))

  return (
    <div {...props}>
      <div className="card-draggable-area card-title">Recent Trades</div>
      <div className="card-content">
        <div className="trade-history-list-header">
          <div className="price-cell align-left">Price</div>
          <div className="size-cell align-right">Size</div>
          <div className="time-cell align-right">Time</div>
        </div>
        <div className="trade-history-list">{tradeHistoryList}</div>
      </div>
      {children}
    </div>
  )
})
